<template>
  <div class="template">
    <img class="top-picc-2" src="@/assets/images/template/picc-icon2.jpg" />
    <div class="redline"></div>
    <div class="top-title">借款人意外保障证明函</div>
    <div class="num-con">
      编号：
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="p-content">
            兹证明
            <span class="key">“青岛鑫诚泰网络科技有限公司”</span>销售的
            <span class="key">借款人意外保障</span>
            已向中国人寿财产保险股份有限公司投保。保险合同中双方约定的保险期限、承保区域、保险责任、赔偿处理、索赔材料的内容如下：
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">一.保障期限：</div>
          <div
            class="p-content"
          >自证明函生效之日起{{swapper(selectYear)}}年有效。在保障期限内，如发生车辆转让，原保险责任立即中止。</div>
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.保障地域范围：</span>中华人民共和国境内(不含港、澳、台)
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.保障责任：</div>
          <div class="p-content">
            安装该产品车辆的第一受益人为<span class="p-underline">{{showDate.saleslip.firstbeneficiaryname}}</span>，在保障期间内，被保障人遭受意外伤害事故，并自事故发生日起一百八十日内因该事故身故或全残，按本保障合同载明的保障金额给付第一受益人被保障人未还款本金，对该被保障人的保障责任终止，赔付限额最高<span class="p-underline">{{showDate.saleslip.compensation*1.2}}</span>元
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">四.除外责任：</div>
          <div class="p-content">
           因下列原因造成车主人身故或伤残的，保障人不承担给付保障金责任：（一）被保障人的故意行为；（二）被保障人自致伤害或自杀；（三）因被保障人挑衅或故意行为而导致的打斗、被袭击或被谋杀；（四）被保障人违法、犯罪或者抗拒依法采取的刑事强制措施；（五）被保障人因疾病、妊娠、流产、分娩导致的伤害，但意外伤害所致的流产或分娩不在此限；（六）被保障人因药物过敏、整容手术、其他内外科手术或其他诊疗活动导致的伤害；（七）被保障人未遵医嘱，私自服用、涂用、注射药物；（八）被保障人因意外伤害、自然灾害事故以外的原因失踪而被法院宣告死亡的；（九）被保障人进行潜水、跳伞、滑雪、滑水、滑翔、狩猎、攀岩、探险、武术、摔跤、特技、赛马、赛车、蹦极、卡丁车等高风险运动和活动；（十）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；（十一）恐怖袭击。<br>被保障人在下列期间遭受伤害导致身故或伤残的，保障人也不承担给付保障金责任：<br>
           （一）被保障人精神失常或精神错乱期间；（二）战争、军事行动、暴动或武装叛乱期间；（三）被保障人醉酒或毒品、管制药物的影响期间；（四）被保障人酒后驾驶、无有效驾驶证驾驶或驾驶无有效行驶证的机动车期间。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.索赔材料：</div>
          <div class="p-content">
           1、购买及安装本产品的凭证、交费凭证；2、被保险车辆的行驶证、车辆登记证、原始购车发票、购置税本、车辆购置税发票，原车的所有钥匙，每缺少一项，增加1%的免赔；3、机动车辆保险单、出险通知书、权益转让书；4、被保险车辆出险后保险公司理赔资料复印件及保险公司付款证明；5、保险人要求的其他相关材料。 
          </div>
        </td>
      </tr>
    </table>
    <div class="personal-title">车主信息</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">车主姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>固定电话</td>
        <td colspan="2"></td>
        <td>移动电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="2">{{showDate.saleslip.address}}</td>
        <td>证明函金额</td>
        <td colspan="2">{{showDate.saleslip.policyamount}}</td>
      </tr>
      <tr>
        <td>车牌号码</td>
        <td>{{showDate.saleslip.carnum}}</td>
        <td width="130">车架号</td>
        <td>{{showDate.saleslip.frame}}</td>
        <td width="130">车辆登记日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>发动机号</td>
        <td>{{showDate.saleslip.enginenum}}</td>
        <td>产品编号</td>
        <td>{{showDate.saleslip.devicenum}}</td>
        <td>安装日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.installtime)}}</td>
      </tr>
      <tr>
        <td>安装地点</td>
        <td colspan="3">{{showDate.saleslip.installaddress}}</td>
        <td>安装人员</td>
        <td>{{showDate.saleslip.installman}}</td>
      </tr>
    </table>
    <p class="tips">注：该产品安装之日起保修36个月，若产品在保修期间出现故障，用户未到指定部门维修服务，后果自负。</p>
    <p
      class="tips"
    >产品销售公司：(签章)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;车主签名：</p>
    <p class="tips">有效期:{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}</p>
    <p class="tips">全国统一客服热线：4006601517</p>
  
    <img class="inis-1" src="@/assets/images/inis.png" alt />
  </div>
</template>

<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch (n) {
        case 1:
          return "壹";
        case 2:
          return "贰";
        case 3:
          return "叁";
        case 4:
          return "肆";
        case 5:
          return "伍";
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/s9.vue